module.exports = __webpack_public_path__ + "static/media/logo-white.047842b1.png";